import Box from '@mui/material/Box';
import React from 'react';
import { QueryKey, useIsFetching } from '@tanstack/react-query';
import { SESSION_LIST_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionListDetails';
import { SESSION_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionsDetails';

type SuspenseLoadingViewProps = {
  children: React.ReactNode;
  loadFallback: React.ReactElement;
  queryKey?: QueryKey;
  fullWidth?: boolean;
  forceLoadFallback?: boolean;
};

export const SuspenseLoadingView: React.FC<SuspenseLoadingViewProps> = ({
  children,
  loadFallback,
  queryKey,
  fullWidth = false,
  forceLoadFallback,
}) => {
  const numberOfFetches = useIsFetching({
    queryKey,
    predicate: (query) => {
      if (Array.isArray(query.queryKey)) {
        return !query.queryKey?.some(
          (key: string) =>
            key === 'Pagination' ||
            key === 'sims' ||
            key === 'Enability' ||
            key === 'availableActions' ||
            key === SESSION_LIST_DETAILS_QUERY_KEY ||
            key === SESSION_DETAILS_QUERY_KEY,
        );
      }

      return true;
    },
  });

  return (
    <React.Suspense fallback={loadFallback}>
      {numberOfFetches > 0 || forceLoadFallback ? React.cloneElement(loadFallback) : null}
      {!forceLoadFallback && (
        <Box
          sx={{
            display: numberOfFetches === 0 ? 'block' : 'none',
            height: numberOfFetches === 0 ? '100%' : '0',
            ...(fullWidth ? { width: '100%' } : {}),
          }}
        >
          {children}
        </Box>
      )}
    </React.Suspense>
  );
};
